export default __webpack_public_path__ + "static/iconfinder_6_3319634-4334eee485002d00566e5e9a1dd8ddd7.png";